/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { createViewerRelationshipHook } from '../../core/factories/createViewerRelationshipHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetFollowsCheckRow } from '../openapi-types.gen.js';
import { type useGetFollowsCheckArgs, useGetFollowsCheckSpec } from '../specs/users.spec.gen.js';

export type { GetFollowsCheckRow } from '../openapi-types.gen.js';
export type { useGetFollowsCheckArgs } from '../specs/users.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): userId, kind.
 */
export const useGetFollowsCheck = createViewerRelationshipHook(useGetFollowsCheckSpec);


/**
 * Hover/intent prefetch companion for `useGetFollowsCheck`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetFollowsCheck();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetFollowsCheck = createPrefetchHook(useGetFollowsCheckSpec);
